import React, { useEffect, useState } from "react";
import { Box, Grid, Typography, Paper, Chip, Button } from "@mui/material";
import { useNavigate, useParams } from "react-router";
import { authenticationService } from "src/services";
import { post } from 'src/services/httpClient.service'

const WatchoDetails = () => {
  const {id} = useParams()
  const navigate = useNavigate()
  const API_URL = process.env.REACT_APP_BASE_API_URL
  const [watcho, setWatcho] = useState(null)
  const { vendorId } = authenticationService.getVendorFranchiseIds()

  const appIntegrations = localStorage.getItem('appIntegrations');
  const appIntegrationsList: string[] = appIntegrations ? JSON.parse(appIntegrations) : [];
  useEffect(() => {
    if (!appIntegrationsList.includes("WATCHO")) {
      navigate("/Thirdparty/ThirdPartyApps");
      return null;
    }
  }, [navigate]);
  /* const watcho = {
    id: 170418,
    SubscriptionPlanID: 170418,
    SubscriptionPlanName: "Watcho_TELEFLICKS1_1M",
    SubscriptionPlanDescription: "12 Apps in One Plan",
    SubscriptionPlanDuration: 1,
    SubscriptionPrice: 65,
    Discount: 0,
    SubscriptionActualPrice: 65,
    IsSubscribed: 0,
    AutoDebitMode: false,
    AutoDebitModeValue: 0,
    SubscriptionSeqNo: 1,
    SubscriptionGroupNo: 255,
    MonthlyPrice: 55,
    SubscriptionApps: null,
    SubscriptionRule: null,
    PGSubscriptionID: ""
  } */

    const getWatchoDetails = async () => {
  try {
    const response = await post(`${API_URL}/api/watcho/vendor/${vendorId}/plans`)
    const plans = response?.Result || []

    const selectedPlan = plans.find(
      (plan) => String(plan.SubscriptionPlanID) === String(id)
    )

    setWatcho(selectedPlan)

  } catch (err) {
    console.log(err)
  }
}
    useEffect(() => {
  if (id) {
    getWatchoDetails()
  }
}, [id])
if (!watcho) {
  return (
    <Typography variant="h6" sx={{ p: 3 }}>
      Plan details not available
    </Typography>
  )
}
  const fields = [
    { label: "Plan ID", value: watcho.SubscriptionPlanID,color: "rgba(212, 155, 11, 0.08)" },
    { label: "Plan Name", value: watcho.SubscriptionPlanName, color: "rgba(156,39,176,0.08)" },
    { label: "Description", value: watcho.SubscriptionPlanDescription, color: "rgba(255,152,0,0.08)" },
    { label: "Duration (Month)", value: watcho.SubscriptionPlanDuration, color: "rgba(0,150,136,0.08)" },
    { label: "Price", value: `₹${watcho.SubscriptionPrice}`, color: "rgba(76,175,80,0.08)" },
    { label: "Actual Price", value: `₹${watcho.SubscriptionActualPrice}`, color: "rgba(244,67,54,0.08)" },
    { label: "Monthly Price", value: `₹${watcho.MonthlyPrice}`, color: "rgba(63,81,181,0.08)" },
    { label: "Discount", value: watcho.Discount, color: "rgba(255,87,34,0.08)" },
    { label: "Subscription Seq No", value: watcho.SubscriptionSeqNo, color: "rgba(0,188,212,0.08)" },
    { label: "Subscription Group No", value: watcho.SubscriptionGroupNo, color: "rgba(121,85,72,0.08)" },
    { label: "PG Subscription ID", value: watcho.PGSubscriptionID || "N/A", color: "rgba(158,158,158,0.08)" }
  ];

  


  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 3,
        background: "transparent",
        width:"100%"
      }}
    >
      <Box sx={{display:'flex',alignItems:'center',justifyContent:"space-between"}}>
            <Typography variant="h4">Watch Subcription Details</Typography>
            <Button variant="contained" onClick={()=>navigate('/ottwatcho/watcho')}>Back</Button>
        </Box>

        

      <Grid container spacing={2} sx={{marginTop:"10px"}}>
        
        {fields.map((item, index) => (
          <Grid item xs={6} md={4} key={index}>
            <Box
              sx={{
                p: 2,
                borderRadius: 2,
                background: item.color,
                backdropFilter: "blur(6px)",
                transition: "0.25s",
                border: "1px solid rgba(0,0,0,0.05)",
                "&:hover": {
                  transform: "translateY(-3px)",
                  boxShadow: "0 6px 14px rgba(0,0,0,0.08)"
                }
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 600,
                  color: "GrayText"
                }}
              >
                {item.label}
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  mt: 0.5,
                  fontWeight: 600,
                  color: "",
                  wordBreak: "break-word"
                }}
              >
                {item.value}
              </Typography>
            </Box>
          </Grid>
        ))}

        {/* Status Fields */}
        <Grid item xs={6} md={4}>
          <Box
            sx={{
              p: 2,
              borderRadius: 2,
              background: "rgba(76,175,80,0.08)"
            }}
          >
            <Typography variant="caption" sx={{ fontWeight: 600 }}>
              Subscribed
            </Typography>
            <Box mt={1}>
              <Chip
                label={watcho.IsSubscribed ? "Yes" : "No"}
                color={watcho.IsSubscribed ? "success" : "default"}
                size="small"
              />
            </Box>
          </Box>
        </Grid>

        <Grid item xs={6} md={4}>
          <Box
            sx={{
              p: 2,
              borderRadius: 2,
              background: "rgba(255,193,7,0.08)"
            }}
          >
            <Typography variant="caption" sx={{ fontWeight: 600 }}>
              Auto Debit
            </Typography>
            <Box mt={1}>
              <Chip
                label={watcho.AutoDebitMode ? "Enabled" : "Disabled"}
                color={watcho.AutoDebitMode ? "primary" : "default"}
                size="small"
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default WatchoDetails;

